export default __webpack_public_path__ + "static/media/QDCLogo.bdb22d9b.png";